module.exports = __webpack_public_path__ + "static/media/Gotham-BoldItalic.d8bd64fa.woff";